import React from 'react';
import { useParams } from 'react-router-dom';

import AoDetailsComponent from '../../../Components/shared/AoDetailsComponent';
// import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useGetRequest from '../../../hooks/useGetRequest';

function AODescriptionById() {
    // const axiosPrivate = useAxiosPrivate();

    // const [ao, setAo] = useState({});
    let param = useParams();
    //only AO infos : AO , but also we have isExpertAlreadyPostulate
    const {data: ao} = useGetRequest({url: `/ao/getAoById/${param?.AOid}`});

    return (
        <>
            <AoDetailsComponent
                ao={ao?.AO}
                isExpertAlreadyPostulate={ao?.isExpertAlreadyPostulate}
            />
        </>
    );
}
export default AODescriptionById;
